import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    modalCloseContainer: {
        position: "absolute",
    },
    modalCloseButton: {
        border: "1px solid #f7f7f7",
        margin: 5,
    },
    stepChip: {
        width: 32,
        height: 32,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.quaternary.main,
        marginTop: theme.spacing(1),
    },
    qrCodeContainer: {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
    },
    qrCodeImage: {
        width: 200,
        height: 200,
        objectFit: "contain",
        bgColor: "transparent",
    },
}));
